import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import IShopDataResponse from '../../../models/responces/IShopDataResponse';
import { sendAxiosRequest } from '../../utils/sendRequest';

const apiShopData = () =>
  sendAxiosRequest({
    method: 'get',
    headers: { Authorization: api.getToken() },
    url: UrlBuilder.getJsonURL({
      folder: 'category',
      file: 'shop-data'
    }),
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IShopDataResponse>;
export default apiShopData;
